import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';
import { cn } from '@/utils/cn';

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  icon: ReactNode;
  tone?: 'default' | 'danger';
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { label, icon, tone = 'default', className, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type="button"
      aria-label={label}
      title={label}
      className={cn(
        'grid size-8 shrink-0 place-items-center rounded-lg transition-colors duration-200',
        tone === 'danger'
          ? 'text-subtle hover:bg-danger/10 hover:text-danger'
          : 'text-subtle hover:bg-inset hover:text-ink',
        className,
      )}
      {...rest}
    >
      {icon}
    </button>
  );
});
